import { PageHeader, Tabs } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import GetMyInvoicesSettings from "./getMyInvoicesIntegration"

interface IntegrationSettingsInterface {}

const UserIntegrations: React.FC<IntegrationSettingsInterface> = ({}) => {
    const { t } = useTranslation()

    const history = useHistory()

    return (
        <div id="finway-integration-settings" className="w-full">
            <div className="md:hidden">
                <PageHeader ghost={false} onBack={() => history.push("/settings")} title={<h2 className="mb-0">{t("label:integrations")}</h2>} extra={[]}></PageHeader>
            </div>
            <div className="justify-items-center">
                <GetMyInvoicesSettings />
            </div>
        </div>
    )
}

export default UserIntegrations
